const { cELM, createCircuitBreakMessage } = require("../../utils");
const Chat = require("../../chat");

class Calendar {
  constructor(data, placeholder, type, validator) {
    data.values = [];
    this._data = data;
    this.processTimeSlots = (fetchedOpenTimeSlots) => {
      if (!fetchedOpenTimeSlots) return [{}, {}];
      const clinicTimes = {};
      const clientTimes = {};

      for (const timeSlotId in fetchedOpenTimeSlots) {
          const timeSlotInfo = fetchedOpenTimeSlots[timeSlotId];
          if (!timeSlotInfo) {
            continue;
          }
          if (data.hideSlots[timeSlotInfo.appointmentid]) {
            continue;
          }
          const { date, starttime, UTCTime } = timeSlotInfo;
          const clinicDateTime = new Date(`${date} ${starttime}`); // Example: 01/03/2024 08:00
          const clientDateTime = new Date(UTCTime.utc); // Example: 1704286800000 UTC
          clinicTimes[clinicDateTime] = timeSlotInfo;
          clientTimes[clientDateTime] = timeSlotInfo;
      }
      return [clinicTimes, clientTimes];
    };

    const [clinicTimes, clientTimes] = this.processTimeSlots(this._data.fetchedTimeSlots);
    this.clinicTimeSlots = clinicTimes;
    this.clientTimeSlots = clientTimes;
    this.timeZone = 'clinic';
    this.monthStrings = {
      'Jan': '01',
      'Feb': '02',
      'Mar': '03',
      'Apr': '04',
      'May': '05',
      'Jun': '06',
      'Jul': '07',
      'Aug': '08',
      'Sep': '09',
      'Oct': '10',
      'Nov': '11',
      'Dec': '12'
    };
    this.groupSlotsByDate = (openTimeSlots) => {
      const dateHasSlots = {};
      for (const date in openTimeSlots) {
        let dateNoTime = new Date(date);
        dateNoTime = new Date(dateNoTime.getFullYear(), dateNoTime.getMonth(), dateNoTime.getDate());
        if (!dateHasSlots[dateNoTime]) {
          dateHasSlots[dateNoTime] = [];
        };
        dateHasSlots[dateNoTime].push(openTimeSlots[date]);
      };
      return dateHasSlots
    };
    this.dateHasSlots = this.groupSlotsByDate(this.timeZone === 'clinic' ? this.clinicTimeSlots : this.clientTimeSlots);
    this.navInfo = this._data.navInfo;
    this.dateSelectedBool = this._data.dateSelectedBool;
    this.noSlotsReturned = this._data.noSlotsReturned;
    this.receivedLatestTimeslots = this._data.sendingLatestTimeslots;
    this.options = null;

    this.placeholder = placeholder || "";
    this.type = type;
    this.dateChosen = null;
    this.currentTimes = [];
    this.today = this.navInfo.today;
    this.monthsClicked = 0;
    this.monthsClickedMax = 0;
    this.validator = validator;
    this.elements = null;
    this.months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    this.months3Char = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    this.days = ["S", "M", "T", "W", "T", "F", "S"];
    this.days3Char = ["Sun", "Mon", "Tues", "Wed", "Thu", "Fri", "Sat"];
    this.topLevelWrapper = cELM("div", "top-level-wrapper")
    this.element = cELM("div", "option-block calendar calendar-main-container");
    this.twoWeekViewContainer = cELM("div", "two-week-container");
    this.weekViewContainer = cELM("div", "one-week-container");
    this.hideSlots = this._data.hideSlots;
  }

  getELM() {
    return this.element;
  };

  setAutoFocus(v) {
    this._autofocus = v;
  };

  formatDayMonth(dayOrMonth) {
    dayOrMonth = String(dayOrMonth);
    if (dayOrMonth.length === 1) {
      dayOrMonth = '0' + dayOrMonth;
    }
    return dayOrMonth;
  };

  hideCurrentSlots() {
    this._data.values = [];
    this.currentTimes = [];
  };

  getTimeSlot(dateTime) {
    return this.timeZone === 'clinic' ? this.clinicTimeSlots[dateTime] : this.clientTimeSlots[dateTime];
  };

  parseTime(time) {
    time = time.split(':');
    let hours = time[0];
    let minutes = time[1];
    let timeAbrv;
    if (hours > 12) {
        timeAbrv = 'PM'
        hours = hours - 12;
    } else if (hours < 12) {
        timeAbrv = 'AM'
    } else if (hours == 12) {
        timeAbrv = 'PM';
    };
    return `${Number(hours)}:${minutes} ${timeAbrv}`;
  };

  renderTimeAsSelection(op, parentElm) {
    const _self = this;

    const clientFacingDate = op.date;
    op = op.starttime;
    op = op.trim();
    const clientFacingTime = _self.parseTime(op);
    const className = (op || '').indexOf('<div class="rate-') > -1 ? ' rate-opt' : '';
    const _el = cELM("div", 'option' + className);
    _el.id = "only-option";
    _el.onclick = function(evt) {
      _el.classList.toggle("option-active");

      let data = (window.__FN_DATA_WRAPPER) ? window.__FN_DATA_WRAPPER(op) : op;

      data = (typeof data == 'string') ? { text: data, id: _self._data.id } : { ...data, id: _self._data.id };

      const timeSlot = _self.getTimeSlot(new Date(clientFacingDate + " " + clientFacingTime));

      data.text = {
        clientFacingTime,
        clientFacingDate,
        timeSlot
      };

      data.answerKey = _self._data.answerKey;

      _self.dateSelectedBool.bool = true;
      _self.hideSlots[timeSlot.appointmentid] = true; // AB: If the patient selects a timeslot that is no longer valid, it will not be displayed on re-render
      Chat.default.send(data, null, _self.element);
      // GO: Show typing indicator immediately so the user gets visual feedback during the slot-lock EHR call (~1-2s).
      // It also makes scheduler-module no longer :last-child, fading the calendar via existing CSS.
      if (Chat.default.BOT && Chat.default.BOT.showTyping) Chat.default.BOT.showTyping();
    };

    _el.innerHTML = '<div class="option-text">' + clientFacingTime + "</div>";

    parentElm.addELM(_el);
    this.currentTimes.push(_el);
  };

  renderUnavailableSlotMessage() {
    const _self = this;

    const noLongerAvailableBackground = cELM("div", "")
    noLongerAvailableBackground.id = 'no-longer-available-background';

    const noLongerAvailable = cELM("div", "");
    noLongerAvailable.id = 'no-longer-available';
    const flexTop = cELM("div", "");
    flexTop.id = 'no-longer-available-flex-top'
    const flexTopText = cELM("div", "");
    flexTopText.id = 'no-longer-available-flex-top-text';
    flexTopText.innerText = "Sorry that appointment time is no longer available.";
    flexTop.addELM(flexTopText);

    const flexBottom = cELM("div", "")
    flexBottom.id = 'no-longer-available-flex-bottom';
    const okButtonWrapper = cELM("div", "option")
    okButtonWrapper.id = 'no-longer-available-ok';
    const okButton = cELM("div", "option-text")
    okButton.id = 'no-longer-available-ok-text';
    okButton.innerText = "OK";
    okButtonWrapper.addELM(okButton);
    noLongerAvailable.addELM(flexTop);
    flexBottom.addELM(okButtonWrapper);
    noLongerAvailable.addELM(flexBottom)

    const hideUnavailableSlotMessage = () => {
      _self.element.removeELM(noLongerAvailableBackground);
      _self.element.removeELM(noLongerAvailable);
    }

    noLongerAvailableBackground.onclick = hideUnavailableSlotMessage;
    okButton.onclick = hideUnavailableSlotMessage;

    _self.element.addELM(noLongerAvailableBackground);
    _self.element.addELM(noLongerAvailable)
  };

  removeFooterButton() {
    const currentFooter = this.element.querySelector('.calendar-footer-button');
    if (currentFooter) {
      const parent = currentFooter.parentNode;
      parent.removeELM(currentFooter);
    };
  };

  renderFooterButton() {
    this.removeFooterButton();

    const footerButton = cELM("div", "calendar-footer-button");
    footerButton.innerText = this.navInfo.screen === 2 ? "View following week" : "View following 2 weeks"
    footerButton.onclick = (() => this.navigateForward());
    this.element.addELM(footerButton);
  }

  renderNoAvailableDatesView() {
    const noAvailableDates = cELM('div', 'no-available-dates-view');
    noAvailableDates.textContent = this._data.customTexts?.noSlotsAvailable || 'This type of appointment does not have any open dates to schedule online at this time. Please contact our office directly for assistance.';
    this.element.addELM(noAvailableDates);
  };

  renderTwoWeekView() {
    this.renderNavBar();

    const twoWeekViewWrapper = cELM("div", "calendar wrapper");

    twoWeekViewWrapper.addELM(this.twoWeekViewContainer);

    if (!this._data.loadingMoreSlots.bool) {
      this.element.addELM(twoWeekViewWrapper);
      this.renderFooterButton();
    }
  };

  renderWeekView() {
    this.renderNavBar();

    const weekViewWrapper = cELM("div", "calendar wrapper");

    weekViewWrapper.addELM(this.weekViewContainer);

    if (!this._data.loadingMoreSlots.bool) {
      this.element.addELM(weekViewWrapper);
      this.renderFooterButton();
    }
  };

  renderMonthView() {
    const _self = this;
    const navInfo = _self.navInfo;
    _self.removeNavBar();

    const monthViewWrapper = cELM("div", "calendar month-view");

    const monthViewContainer = cELM("div", "container-month-view");
    monthViewWrapper.addELM(monthViewContainer);

    const selectADateBlurb = cELM("div", "select-a-date-blurb");
    selectADateBlurb.innerText = "Select a date below";

    const buttonContainerMonthView = cELM("div", "button-container-month-view");
    monthViewContainer.addELM(selectADateBlurb);
    monthViewContainer.addELM(buttonContainerMonthView);

    const previousBtn = cELM("button", "");
    previousBtn.id = 'previous';
    previousBtn.onclick = previous;
    previousBtn.innerHTML = '&#8249;';
    buttonContainerMonthView.addELM(previousBtn);

    const monthAndYear = cELM("h3", "")
    monthAndYear.id = 'monthAndYear';
    buttonContainerMonthView.addELM(monthAndYear);

    const nextBtn = cELM("button", "");
    nextBtn.id = 'next';
    nextBtn.onclick = next;
    nextBtn.innerHTML = '&#8250;';
    buttonContainerMonthView.addELM(nextBtn);

    const tableCalendar = cELM("table", "table-month-view")
    tableCalendar.id = 'month-view';
    const tHead = cELM("thead", "");
    tHead.id = 'thead-month';
    const tBody = cELM("tbody", "");
    tBody.id = 'month-view-body';
    tableCalendar.addELM(tHead);
    tableCalendar.addELM(tBody);
    monthViewContainer.addELM(tableCalendar);

    const months = this.months;
    const days = this.days;

    let $dataHead = "<tr>";
    for (dhead in days) {
      $dataHead += "<th data-days='" + days[dhead] + "'>" + days[dhead] + "</th>";
    }
    $dataHead += "</tr>";

    tHead.innerHTML = $dataHead;

    function next() {
      navInfo.navYear = (navInfo.navMonth === 11) ? navInfo.navYear + 1 : navInfo.navYear;
      navInfo.navMonth = (navInfo.navMonth + 1) % 12;

      const dateToCompare = new Date(navInfo.navYear, navInfo.navMonth);
      const newMaxMonthYear = _self.checkIfShouldLoadMoreSlots(dateToCompare);
      if (newMaxMonthYear) {
        _self.loadMoreSlots(newMaxMonthYear.getFullYear(), newMaxMonthYear.getMonth());
      };
      showCalendar(navInfo.navMonth, navInfo.navYear);
    };

    function previous() {
      navInfo.navYear = (navInfo.navMonth === 0) ? navInfo.navYear - 1 : navInfo.navYear;
      navInfo.navMonth = (navInfo.navMonth === 0) ? 11 : navInfo.navMonth - 1;
      showCalendar(navInfo.navMonth, navInfo.navYear);
    };

    showCalendar(navInfo.navMonth, navInfo.navYear);

    function showCalendar(month, year, hideSlots) {

      if (month === _self.today.getMonth() && year === _self.today.getFullYear()) {  // AB: Disable navigation before today
        previousBtn.disabled = true;
        previousBtn.className = 'btn-not-allowed';
      } else {
        previousBtn.disabled = false;
        previousBtn.className = '';
      };

      nextBtn.disabled = false;
      nextBtn.className = '';

      let firstDay = (new Date(year, month)).getDay();
      tBody.innerHTML = "";
      monthAndYear.innerHTML = months[month] + " " + year;
      let date = 1;
      for (let i = 0; i < 6; i++) {
          let row = cELM("tr");

          for (let j = 0; j < 7; j++) {
              let cell
              if (i === 0 && j < firstDay) {
                  cell = cELM("td");
                  let cellText = cELM("span");
                  cellText.innerText = "";
                  cell.appendChild(cellText);
                  row.appendChild(cell);
              } else if (date > daysInMonth(month, year)) {
                  break;
              } else {
                  cell = cELM("td");
                  cell.setAttribute("data-date", date);
                  cell.setAttribute("data-month", month + 1);
                  cell.setAttribute("data-year", year);
                  cell.setAttribute("data-month_name", months[month]);
                  cell.className = "date-picker";

                  let dateStr = new Date(year, month, date);
                  let compareDay = new Date(`${month+1}/${date}/${year}`);

                  if (hideSlots) {
                    cell.innerHTML = "<span class=invalid-date>" + date + "</span>";
                  } else if (_self.dateHasSlots[dateStr] && compareDay >= _self.today) {
                    cell.innerHTML = "<span>" + date + "</span>";

                    cell.onclick = (() => {
                      _self.navInfo.navDay = Number(cell.innerText);
                      _self.selectScreen(2)
                    });
                  } else {
                    cell.innerHTML = "<span class=invalid-date>" + date + "</span>";
                  }

                  if (date === _self.today.getDate() && year === _self.today.getFullYear() && month === _self.today.getMonth()) {
                      cell.className = "date-picker selected";
                  }

                  row.appendChild(cell);
                  date++;
              }
          }
          tBody.appendChild(row);
      }
    }

    function daysInMonth(iMonth, iYear) {
      return 32 - new Date(iYear, iMonth, 32).getDate();
    }

    this.element.addELM(monthViewWrapper);
  };

  removeNavBar() {
    const navBar = this.element.querySelector('.calendar-nav-bar-wrapper');
    if (navBar) {
      this.element.removeELM(navBar);
    };
  };

  removeCalendarWrapper() {
    const calendarWrapper = this.element.querySelector('.calendar.wrapper');
    if (calendarWrapper) {
      this.element.removeELM(calendarWrapper);
    };
  };

  calculateDaysForwardOrBackward(numberOfDays, jump, oneDayOffset, backward) {
    let startDate = new Date(`${this.navInfo.navMonth+1}/${this.navInfo.navDay}/${this.navInfo.navYear}`);

    if (jump) {
      if (backward) {
        startDate = new Date(startDate.setDate(startDate.getDate() - (oneDayOffset ? 1 : 0)));
      } else {
        startDate = new Date(startDate.setDate(startDate.getDate() + numberOfDays + (oneDayOffset ? 1 : 0)));
      }
    };

    let targetDate = new Date(startDate);
    if (backward) {
      targetDate = new Date(targetDate.setDate(targetDate.getDate() - numberOfDays));
    } else {
      targetDate = new Date(targetDate.setDate(targetDate.getDate() + numberOfDays));
    };

    if (backward) { // AB: Check if out of bounds going back
      if (targetDate < this.navInfo.today) {
        startDate = new Date(this.navInfo.today);
        startDate = new Date(startDate.setDate(startDate.getDate() + numberOfDays));
        targetDate = this.navInfo.today;
      }
    }

    return backward ? [targetDate, startDate] : [startDate, targetDate];
  };

  dateRangeIterator(startDate, endDate, callback) {
    let nextAvailableDate = null;
    let iterateDate = new Date(startDate);
    while (iterateDate <= endDate) {
      const slotsAtDate = this.dateHasSlots[iterateDate] || [];
      slotsAtDate.sort((a,b) => {  // AB: Sorting timeslots by their time in the day
        return a.starttime < b.starttime ? -1 : 1;
      });
      if (!nextAvailableDate) {
        nextAvailableDate = slotsAtDate.length ? new Date(iterateDate) : null;
      };
      if (callback) {
        callback({slotsAtDate, iterateDate: new Date(iterateDate)});
      }
      iterateDate = new Date(iterateDate.setDate(iterateDate.getDate() + 1));
    }
    return nextAvailableDate;
  };

  updateNavInfoNoRender(date) {
    this.navInfo.navDay = date.getDate();
    this.navInfo.navMonth = date.getMonth();
    this.navInfo.navYear = date.getFullYear();
    this.navInfo.navFullDate = new Date(this.navInfo.navYear, this.navInfo.navMonth, this.navInfo.navDay);
  };

  renderTimeSlots() {
    const _self = this;
    _self.navInfo.nextAvailableDate = null;

    if (this.navInfo.screen === 1) { // AB: Update twoWeekView
      _self.twoWeekViewContainer = cELM("div", "two-week-container");
      _self.navInfo.nextAvailableDate = this.dateRangeIterator(this.navInfo.navFullDate, this.navInfo.navEndDate, (slotInfoAtDate) => {
        const slotsAtDate = slotInfoAtDate.slotsAtDate;
        const date = slotInfoAtDate.iterateDate;
        const dayOfWeekAbrv = this.days3Char[date.getDay()];
        const monthAbrv = this.months3Char[date.getMonth()];
        const dayOfMonth = date.getDate();

        let twoWeekViewCell;
        if (slotsAtDate.length) {
          twoWeekViewCell = cELM("div", "two-week-cell");
        } else {
          twoWeekViewCell = cELM("div", "two-week-cell no-slots");
        };

        twoWeekViewCell.innerHTML = `<div>${dayOfWeekAbrv}<br>${monthAbrv} ${dayOfMonth}</div><div>${slotsAtDate.length || "No"}<br>appts</div>`;

        if (slotsAtDate.length) {
          twoWeekViewCell.onclick = (() => {
            _self.updateNavInfoNoRender(date);
            _self.selectScreen(2)
          });
        };

        _self.twoWeekViewContainer.addELM(twoWeekViewCell);
      });
      const twoWeekView = _self.element.querySelector('.two-week-container');
      if (twoWeekView) {
        const parent = twoWeekView.parentNode;
        parent.removeELM(twoWeekView);
        parent.addELM(_self.twoWeekViewContainer);
      };
    } else if (this.navInfo.screen === 2) { // AB: Update week view
      _self.weekViewContainer = cELM("div", "one-week-container");
      _self.navInfo.nextAvailableDate = this.dateRangeIterator(this.navInfo.navFullDate, this.navInfo.navEndDate, (slotInfoAtDate) => {
        const slotsAtDate = slotInfoAtDate.slotsAtDate;
        const date = slotInfoAtDate.iterateDate;
        const dayOfWeekAbrv = this.days3Char[date.getDay()];
        const monthAbrv = this.months3Char[date.getMonth()];
        const dayOfMonth = date.getDate();

        const dayContainer = cELM("div", "day-dates-wrapper");
        const dayTitle = cELM("div", "day-title");
        dayTitle.innerText = `${dayOfWeekAbrv}, ${monthAbrv} ${dayOfMonth}`;
        dayContainer.addELM(dayTitle);
        const datesContainer = cELM("div", "dates-container");
        dayContainer.addELM(datesContainer);

        if (slotsAtDate.length) {
          for (const slotInfo of slotsAtDate) {
            this.renderTimeAsSelection(slotInfo, datesContainer);
          };
        } else {
          const noSlotsAvailable = cELM("div", "slot-no-availability");
          noSlotsAvailable.innerText = "No availability";
          datesContainer.addELM(noSlotsAvailable);
        };

        _self.weekViewContainer.addELM(dayContainer);
      });
      const weekView = _self.element.querySelector('.one-week-container');
      if (weekView) {
        const parent = weekView.parentNode;
        parent.removeELM(weekView);
        parent.addELM(_self.weekViewContainer);
      };
    }

    if (!_self.navInfo.nextAvailableDate) {

      const currNavEndDate = new Date(_self.navInfo.navEndDate);
      _self.navInfo.nextAvailableDate = _self.dateRangeIterator(new Date(currNavEndDate.setDate(currNavEndDate.getDate() + 1)), _self.navInfo.maxNavigatedMonthYear);
      if (!_self.navInfo.nextAvailableDate) {
        let nextMonth = new Date(_self.navInfo.maxNavigatedMonthYear);
        _self.navInfo.maxNavigatedMonthYear = new Date(nextMonth.setMonth(nextMonth.getMonth() + 1));
        return _self.loadMoreSlots(_self.navInfo.maxNavigatedMonthYear.getFullYear(), _self.navInfo.maxNavigatedMonthYear.getMonth());
      }

    };

  };

  displayNextAvailableDate() {
    const nextAvailableDateButton = this.element.querySelector('.next-available-date-btn');

    if (this.navInfo.nextAvailableDate) {
      nextAvailableDateButton.innerHTML = `<img src="https://self-schedule-assets.s3.amazonaws.com/chatbot/clock.svg"><div>Next Available: ${this.days3Char[this.navInfo.nextAvailableDate.getDay()]}, ${this.months3Char[this.navInfo.nextAvailableDate.getMonth()]} ${this.navInfo.nextAvailableDate.getDate()}</div>`;

      nextAvailableDateButton.onclick = (() => {
        this.updateNavInfoNoRender(this.navInfo.nextAvailableDate);
        this.selectScreen(2)
      });

    } else if (this._data.loadingMoreSlots.bool) {
      nextAvailableDateButton.innerText = `Loading future dates...`;
    } else {
      nextAvailableDateButton.innerText = `No future dates available`;
    }

    // Found no dates at all
    if (this.noAvailableDates()) {
      if (this._data.sendingLatestTimeslots) {
        console.log('Going to display no-slots message...');
        this.selectScreen(4);
      } else {
        console.log('Get fetched timeslots one more time...');
        // Try to get fetched time slots one more time before displaying the no-slots message,
        // in case the time slots have an outdated value.
        Chat.default.send({ action: 'getLatestTimeslots' }, null, this.element);
      }
    }

    switch(this.navInfo.screen) {
      case 1:
        nextAvailableDateButton.classList = "next-available-date-btn";
        break
      case 2:
        nextAvailableDateButton.classList = this.currentTimes.length ? "next-available-date-btn hidden" : "next-available-date-btn";
        break;
      case 3:
        nextAvailableDateButton.classList = "next-available-date-btn";
        break;
      default:
        break;
    };
  };

  updateNavInfo(startDate, endDate) {
    this.hideCurrentSlots();
    this.navInfo.navDay = startDate.getDate();
    this.navInfo.navMonth = startDate.getMonth();
    this.navInfo.navYear = startDate.getFullYear();
    this.navInfo.navFullDate = new Date(this.navInfo.navYear, this.navInfo.navMonth, this.navInfo.navDay);
    this.navInfo.navEndDate = endDate;
    this.renderTimeSlots();
    this.displayNextAvailableDate();
  };

  updateNavBar(date) {
    const navBarCenter = this.element.querySelector('.calendar-nav-bar-center');
    if (navBarCenter) {
      navBarCenter.innerHTML = this.createNavDateString(date);
    }
  };

  checkIfShouldLoadMoreSlots(date) {
    if (this.receivedLatestTimeslots) {
        return false;
    }
    const possibleNewMaxMonthYear = new Date(date.getFullYear(), date.getMonth());
    if (possibleNewMaxMonthYear > this.navInfo.maxNavigatedMonthYear) {
      this.navInfo.maxNavigatedMonthYear = possibleNewMaxMonthYear;
      return possibleNewMaxMonthYear;
    };
  };

  navigateForward() {
    let newDates;
    switch(this.navInfo.screen) {
      case 1:
        newDates = this.calculateDaysForwardOrBackward(13, true, true);
        break;
      case 2:
        newDates = this.calculateDaysForwardOrBackward(6, true, true);
        break;
      default:
        break;
    }

    this.updateNavInfo(newDates[0], newDates[1]);
    this.updateNavBar(newDates[1]);
    const newMaxMonthYear = this.checkIfShouldLoadMoreSlots(newDates[1]);
    if (newMaxMonthYear) {
      this.loadMoreSlots(newMaxMonthYear.getFullYear(), newMaxMonthYear.getMonth());
    };
  };

  navigateBackward() {
    let newDates;
    switch(this.navInfo.screen) {
      case 1:
        newDates = this.calculateDaysForwardOrBackward(13, true, true, true);
        break;
      case 2:
        newDates = this.calculateDaysForwardOrBackward(6, true, true, true);
        break;
      default:
        break;
    }

    this.updateNavInfo(newDates[0], newDates[1]);
    this.updateNavBar(newDates[1]);
  };

  createNavDateString(endDate) {
    return `<img src="https://self-schedule-assets.s3.amazonaws.com/chatbot/calendar.svg"><div>${this.months3Char[this.navInfo.navMonth]} ${this.navInfo.navDay} - ${this.months3Char[endDate.getMonth()]} ${endDate.getDate()}</div>`;
  };

  disableElm(elm) { // AB: Pass in element such as nav arrow so we can disable it before mount
    if (!elm) {
      return;
    }
    elm.disabled = "disabled";
    elm.onclick = null;
  };

  disableMountedNav() {
    this.disableElm(this.element.querySelector('.nav-arrow-left'));
    this.disableElm(this.element.querySelector('.nav-arrow-right'));
    this.disableElm(this.element.querySelector('.calendar-nav-bar-center'));
  };

  renderNavBar() {
    this.removeNavBar();
    const navBarWrapper = cELM("div", "calendar-nav-bar-wrapper");
    const navBar = cELM("div", "calendar-nav-bar-container");
    navBarWrapper.addELM(navBar);

    const navBarCenter = cELM("div", "calendar-nav-bar-center");

    let newDates;
    switch(this.navInfo.screen) {
      case 1:
        newDates = this.calculateDaysForwardOrBackward(13);
        break;
      case 2:
        newDates = this.calculateDaysForwardOrBackward(6);
        break;
      default:
        break;
    };

    this.updateNavInfo(newDates[0], newDates[1]);
    navBarCenter.innerHTML = this.createNavDateString(newDates[1]);
    navBarCenter.onclick = (() => this.selectScreen(3));

    const arrowLeft = cELM("div", "nav-arrow-left");
    arrowLeft.innerHTML = '&#8249;';
    const dividerLeft = cELM("div", "nav-divider");

    const arrowRight = cELM("div", "nav-arrow-right");
    arrowRight.innerHTML = '&#8250;';
    const dividerRight = cELM("div", "nav-divider");


    const navLeftContainer = cELM("div", "nav-side-container-left");
    navLeftContainer.addELM(arrowLeft);
    navLeftContainer.addELM(dividerLeft);
    navLeftContainer.onclick = (() => this.navigateBackward());
    navBar.addELM(navLeftContainer);

    navBar.addELM(navBarCenter);

    const navRightContainer = cELM("div", "nav-side-container-right");
    navRightContainer.addELM(dividerRight);
    navRightContainer.addELM(arrowRight);
    navRightContainer.onclick = (() => this.navigateForward());
    navBar.addELM(navRightContainer);

    this.element.addELM(navBarWrapper);

    const newMaxMonthYear = this.checkIfShouldLoadMoreSlots(newDates[1]);
    if (newMaxMonthYear) {
      this.loadMoreSlots(newMaxMonthYear.getFullYear(), newMaxMonthYear.getMonth());
    };
  };

  noAvailableDates() {
    const nextAvailableDateButton = this.element.querySelector('.next-available-date-btn');
    return nextAvailableDateButton.innerText === 'No future dates available' && Object.keys(this._data.fetchedTimeSlots || {}).length === 0;
  }

  selectScreen(screen) {
    const currentView = this.element.querySelector('.calendar');
    if (currentView) {
      this.element.removeELM(currentView);
    };

    this.navInfo.screen = screen;
    switch(screen) {
      case 1:
        this.renderTwoWeekView();
        break;
      case 2:
        this.renderWeekView();
        break;
      case 3:
        this.hideCurrentSlots();
        this.removeFooterButton();
        this.displayNextAvailableDate();
        const loaderWrapper = this.topLevelWrapper.querySelector(".loader-wrapper");
        if (loaderWrapper) {
          const parent = loaderWrapper.parentNode;
          parent.removeELM(loaderWrapper);
        };
        this.renderMonthView();
        break;
      case 4:
        this.renderNoAvailableDatesView();
        break;
      default:
        break;
    }

    if (this.noAvailableDates()) {
      this.removeNavBar();
      this.removeCalendarWrapper();
      this.removeFooterButton();
    }

    return;
  };

  getApptInfoFromSlots(dateHasSlots) {
    let apptTypeId, locationId, providerId;
    const [key, value] = Object.entries(dateHasSlots || {})[0] || [];
    if (value && value[0] && typeof value[0] === 'object') {
      apptTypeId = value[0].appointmenttypeid;
      locationId = value[0].departmentid;
      providerId = value[0].providerid;
    }
    return { apptTypeId, locationId, providerId };
  };

  loadMoreSlots(year, month) {
    if (this.receivedLatestTimeslots) {
        console.log('Skipping slot search because received latest timeslot already');
        return;
    }

    let loadKey = `${year},${month}`;
    const { apptTypeId, locationId, providerId } = this.getApptInfoFromSlots(this.dateHasSlots);
    if (apptTypeId) loadKey+=`,${apptTypeId}`;
    if (locationId) loadKey+=`,${locationId}`;
    if (providerId) loadKey+=`,${providerId}`;

    if (this._data.loadedMoreSlots?.[loadKey]) {
      // We already loaded slots for this date during this scheduler session. Returning...
      return;
    }

    this.removeFooterButton();

    const loaderWrapper = cELM("div", "loader-wrapper");
    const loaderText = cELM("div", "loading-text");
    loaderText.innerText = "Loading"
    const loader = cELM("div", "dot-flashing");
    loaderWrapper.addELM(loaderText);
    loaderWrapper.addELM(loader);

    let calendarElm;
    switch (this.navInfo.screen) {
      case 1:
        calendarElm = this.element.querySelector('.two-week-container');
        if (calendarElm) {
          const parent = calendarElm.parentNode;
          parent.removeELM(calendarElm);
        }
        if (!this._data.loadingMoreSlots.bool) {
          this.topLevelWrapper.addELM(loaderWrapper);
        }
        break;
      case 2:
        calendarElm = this.element.querySelector('.one-week-container');
        if (calendarElm) {
          const parent = calendarElm.parentNode;
          parent.removeELM(calendarElm);
        }
        if (!this._data.loadingMoreSlots.bool) {
          this.topLevelWrapper.addELM(loaderWrapper);
        }
        break;
      case 3:
        calendarElm = this.element.querySelector('.table-month-view');
        if (calendarElm) {
          const parent = calendarElm.parentNode;
          parent.removeELM(calendarElm);
        }
        if (!this._data.loadingMoreSlots.bool) {
          this.topLevelWrapper.addELM(loaderWrapper);
        }
        break
      default:
        break;
    }

    this._data.loadingMoreSlots.bool = true;
    if (this._data.loadedMoreSlots) {
      this._data.loadedMoreSlots[loadKey] = true;
    }
    Chat.default.send({ action: 'loadMoreSlots', dateToLoadFrom: `${month+1}/1/${year}`, optimisticLocking: { 'selected-timeslot': null } }, null, this.element);
  };

  getHTML() {
    const _self = this;
    const navInfo = _self.navInfo;
    this.topLevelWrapper.addELM(this.element);

    if (this._data.invalidTimeSlot) {
      _self.renderUnavailableSlotMessage();
    }

    if (this._data.circuitBreakError) {
      _self.element.addELM(createCircuitBreakMessage());
    }

    const nextAvailableDateButton = cELM("div", "next-available-date-btn hidden");
    _self.element.addELM(nextAvailableDateButton);

    if (!this.navInfo.initialLoaded) { // AB: Load an additional month of timeslots if 2 weeks view is split between 2 months on initial calendar load
      this.navInfo.initialLoaded = true;
      const newDates = this.calculateDaysForwardOrBackward(13);
      const newMaxMonthYear = this.checkIfShouldLoadMoreSlots(newDates[1]);
      if (newMaxMonthYear) {
        this.loadMoreSlots(newMaxMonthYear.getFullYear(), newMaxMonthYear.getMonth());
      }
    };

    if (this.noSlotsReturned) {
      let nextMonth = new Date(this.navInfo.maxNavigatedMonthYear);
      this.navInfo.maxNavigatedMonthYear = new Date(nextMonth.setMonth(nextMonth.getMonth() + 1));
      this.loadMoreSlots(this.navInfo.maxNavigatedMonthYear.getFullYear(), this.navInfo.maxNavigatedMonthYear.getMonth());
    };

    this.selectScreen(navInfo.screen);
    return this.topLevelWrapper;
  };

  reset() {
    this.element.firstChild.value = "";
    this.element.firstChild.focus();
  };

  focus() {
    // this.elements.el.click();
    //this.elements.el.focus();
  };
};



module.exports = Calendar;
